module.exports = __webpack_public_path__ + "img/fortress_tech_Normal_ua.06c0831d.webp";